import React from 'react';
import styled from '../../theme/styled';

import placeholder from '../../images/team/placeholder.jpg';

interface MemberProps extends MemberImageProps {
    name: string;
    position: string;
    phone: string;
    email: string;
}

interface MemberImageProps {
    image_url: string;
}

const MemberContainer = styled.li`
    text-align: center;
    padding: 45px;
    display: flex;
    flex-direction: column;
    flex-basis: 400px;
`;

const MemberImage = styled.div<MemberImageProps>`
    width: 100%;
    padding-top: 100%;
    background-color: red;
    background-image: url(${props => props.image_url});
    border-radius: 50%;
    background-size: cover;
`;

const NameField = styled.h2`
    margin-top: 50px;
    font-size: 1.5em;
    font-weight: bold;
    color: ${props => props.theme.colors.dark[1]}
`;

const PositionField = styled.h3`
    margin-top: 30px;
    text-transform: uppercase;
    font-size: 1em;
`;

const ContactFields = styled.ul`
    margin-top: 30px;
    li a {
        color: ${props => props.theme.colors.brand[3]};
    }
    li a:hover {
        color: ${props => props.theme.colors.dark[1]};
    }
`;



export class TeamMember extends React.Component<MemberProps> {
    public static defaultProps = {
        image_url: placeholder,
        phone: "",
        email: ""
    };

    render() {
        return <MemberContainer>
            <MemberImage image_url={this.props.image_url}/>
            <NameField>{this.props.name}</NameField>
            <PositionField>{this.props.position}</PositionField>
            <ContactFields>
                <li><a href={"mailto:" + this.props.email}>{this.props.email}</a></li>
                <li>{this.props.phone}</li>
            </ContactFields>
        </MemberContainer>;
    }
}

const MemberListContainer = styled.ul`
    width: 100%;
    display: flex;
    flex-flow: row wrap;
    padding: 0;
    justify-content: space-evenly;
`;

export const MemberList = (props: any) => {
    return <MemberListContainer>{props.children}</MemberListContainer>;
};


// WEBPACK FOOTER //
// ./src/components/base/Team_Member.tsx